export function getCookie(name: string): string {
	var pattern = RegExp(name + "=.[^;]*");
	var matched = document.cookie.match(pattern);
	if (matched) {
		var cookie = matched[0].split("=");
		return cookie[1];
	}
	return "";
}
